// extracted by mini-css-extract-plugin
export default {"keyboardBox":"index_keyboardBox__d1Crd","keyboard":"index_keyboard__t96vO","svgIcon":"index_svgIcon__lV11N","active":"index_active__fhyPb","alert":"index_alert__3t3y3"};